<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Tax Relief Method</h1>
    <p>Pension contributions can be handled in different ways when it comes to tax relief. The two main methods are:</p>
    <ul>
      <li><strong>Relief at Source</strong> – Contributions are taken from the employee’s after-tax pay. The pension provider then claims back basic rate tax from the government and adds it to the employee’s pension pot.</li>
      <li><strong>Net Pay Arrangement</strong> – Contributions are taken from the employee’s before-tax pay, which means they get full tax relief straight away by paying less tax.</li>
    </ul>
    <p>What method of tax relief is your pension scheme?.</p>
    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=RAS v-model="formData.taxRelief">Relief at Source<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=NPA v-model="formData.taxRelief">Net Pay Arrangement<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref(null)

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  if (!props.formData.taxRelief) {
    error.value = 'Please select a tax relief method.';
    return false;
  }
  error.value = null;
  return true;
}



const executeStep = async () => {
  return true;
}



onMounted(() => {
});

defineExpose({ validateStep, executeStep });

</script>